module.exports = __webpack_public_path__ + "resources/img/img_tibero_en.44136217e93d8e67dc0832033513934c.png";